var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mx-auto elevation-0 ma-1 mr-2",style:(_vm.style),attrs:{"outlined":_vm.outlined,"prominent":_vm.prominent,"width":_vm.width}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }